export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f5775f54bfb9b5076bf680cce6532b9bcf8d048d9&name=fetchTypeahead!'